// extracted by css-extract-rspack-plugin
export default {"removeLinkAnchor":"Ffvce","embedCodeContainer":"Ot9b6","copyButtonContainer":"dQOhK","embedCode":"TI_4a"};